import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-literal-field"
  }, [_c(VSelect, {
    staticClass: "mapper-literal-field__type",
    attrs: {
      "value": _vm.value.type,
      "items": _vm.typeItems,
      "label": _vm.typeLabel || _vm.$i18n_t('Bridges.mapperBuilder.literal.type'),
      "disabled": _vm.disabled,
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "data-test": `${_vm.dataTest}-type`
    },
    on: {
      "change": function ($event) {
        return _vm.setType($event);
      }
    }
  }), _vm.value.type === 'boolean' ? _c(VSelect, {
    staticClass: "mapper-literal-field__value",
    attrs: {
      "value": _vm.value.text,
      "items": _vm.booleanItems,
      "label": _vm.label,
      "disabled": _vm.disabled,
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "data-test": `${_vm.dataTest}-value`
    },
    on: {
      "change": function ($event) {
        return _vm.setText($event);
      }
    }
  }) : _vm.value.type === 'json' ? _c(VTextarea, {
    staticClass: "mapper-literal-field__value",
    attrs: {
      "value": _vm.value.text,
      "label": _vm.label,
      "disabled": _vm.disabled,
      "error-messages": _vm.jsonError,
      "auto-grow": "",
      "dense": "",
      "outlined": "",
      "rows": "2",
      "data-test": `${_vm.dataTest}-value`
    },
    on: {
      "input": function ($event) {
        return _vm.setText($event);
      }
    }
  }) : _vm.value.type !== 'null' ? _c(VTextField, {
    staticClass: "mapper-literal-field__value",
    attrs: {
      "value": _vm.value.text,
      "label": _vm.label,
      "type": _vm.value.type === 'number' ? 'number' : 'text',
      "disabled": _vm.disabled,
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "data-test": `${_vm.dataTest}-value`
    },
    on: {
      "input": function ($event) {
        return _vm.setText($event);
      }
    }
  }) : _c('span', {
    staticClass: "mapper-literal-field__null text--secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.literal.nullHint')) + "\n  ")])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };